import { Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthSrcDirective, DEFAULT_PERSON_IMAGE } from '@ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-person-details-form',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    AuthSrcDirective,
  ],
  templateUrl: './person-details-form.component.html',
  styleUrl: './person-details-form.component.scss',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PersonDetailsFormComponent),
    multi: true,
  }],
})
export class PersonDetailsFormComponent implements ControlValueAccessor {
  public readonly imageUrl = input.required<string>();
  public readonly imageUrlFallback = input.required<string>();
  public readonly defaultImage = input<string>(DEFAULT_PERSON_IMAGE);

  public onChange?: (value: string) => void;
  public onTouch?: () => void;

  protected readonly isDisabled = signal<boolean>(false);
  protected readonly nameForm = new FormControl<string>('');

  constructor() {
    this.nameForm.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this.onChange?.(value ?? ''));
  }

  public writeValue(obj: string | null): void {
    this.nameForm.setValue(obj ?? '', { emitEvent: false });
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);

    if (isDisabled) {
      this.nameForm.disable({ emitEvent: false });
    } else {
      this.nameForm.enable({ emitEvent: false });
    }
  }
}
